import RatesBlock from './RatesBlock'
import RatesCardBlock from './RatesCardBlock'

export { RatesBlock, RatesCardBlock }
